import { render, staticRenderFns } from "./RevolutionSlider.vue?vue&type=template&id=98187860&"
import script from "./RevolutionSlider.vue?vue&type=script&lang=js&"
export * from "./RevolutionSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports